module.exports = __webpack_public_path__ + "static/media/ms-pictogram.319d9b9a.svg";